import { createPortal } from 'react-dom'
import React from 'react'
import UserDocuments from '../index'

interface Params {
  id: string;
}

export default function UserDocumentsPortal({ id }: Params) {
  const Root = document.getElementById(id);

  if (!Root) {
    return null
  }


  const userId = Root.getAttribute('data-userId') || Root.getAttribute('data-userid');

  if (!userId) {
    throw new Error('"data-userId" attribute is required')
  }

  return createPortal(<UserDocuments userId={parseInt(userId, 10)} />, Root)
}
